<template>
  <div>
    <v-dialog
      v-if="!$apollo.loading"
      v-model="dialog"
      width="550"
      overlay-color="rgba(39, 50, 64)"
      overlay-opacity="0.6"
      :fullscreen="$vuetify.breakpoint.xs ? true : false"
      persistent
      :transition="false"
    >
      <v-card v-if="me.security.trading_suspended && paused">
        <v-card-title
          class="header info"
          primary-title
        >
          <b> {{ $t('rankings.unpause') }}</b>
        </v-card-title>
        <v-card-text
          class="mt-3"
        >
          {{ $t('rankings.suspended') }} <b>{{ me.security.trading_suspended_at | moment('L LT') }}</b>.
          {{ $t('rankings.suspendedWhy') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="$router.push('/invoices')"
          >
            {{ $t('globals.closeButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title
          class="header info"
          primary-title
        >
          <b> {{ $t(paused ? 'rankings.unpause' : 'rankings.pause') }}</b>
        </v-card-title>

        <v-card-text class="mt-8">
          <v-flex>
            <p
              v-if="!success"
              class="text-justify"
            >
              <span>
                {{ $t(paused ? 'rankings.unpauseHint' : 'rankings.pauseHint') }}
              </span>
            </p>
            <p v-else>
              {{ $t('rankings.pauseSuccess') }}
            </p>
          </v-flex>
        </v-card-text>

        <v-divider />

        <v-card-actions v-if="!success">
          <v-spacer />
          <v-btn
            text
            :disabled="loading"
            @click="$emit('closePauseUnpauseDialog', false)"
          >
            {{ $t("globals.cancelButton") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="loading"
            @click="save()"
          >
            {{ $t(paused ? 'rankings.unpause' : 'rankings.pause') }}
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer />
          <v-btn
            text
            :disabled="loading"
            @click="$emit('closePauseUnpauseDialog', true)"
          >
            {{ $t("globals.closeButton") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>


const PAUSE_CONNECTION_MUTATION = require('@/graphql/mutations/PauseConnection.gql');
const UNPAUSE_CONNECTION_MUTATION = require('@/graphql/mutations/UnpauseConnection.gql');
import USER_SECURITY_QUERY from "@/graphql/queries/UserSecurity.gql";

export default {
  name: "PauseUnpauseDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    paused: {
      type: Boolean,
      default: false
    },
    connectionId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      error: null,
      success: false
    };
  },
  computed: {
    dialog: {
      get() {
        return this.showDialog;
      },
      set(val) {}
    },
  },
  methods: {
    save() {
      this.loading = true;
      let params = {
        connection_id: this.connectionId
      }
      this.$apollo
        .mutate({
          mutation: !this.paused ? PAUSE_CONNECTION_MUTATION : UNPAUSE_CONNECTION_MUTATION,
          variables: params
        })
        .then(data => {
          if (this.paused) {
            this.responseHandler(data)
            this.$emit('closePauseUnpauseDialog', true);
          } else {
            this.success = true
            this.loading = false
          }
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
  apollo: {
    me: {
      query: USER_SECURITY_QUERY
    },
  }
};
</script>

<style></style>
